import { useAppAction, useAppSelector } from '../hooks';
import {
  clearSupportImage,
  createNewServiceCallThunk,
  FetchSupportCategoriesThunk,
  FetchSupportEventsThunk,
  FetchSupportSubCategoriesByCategoryIdThunk,
  removeSupportImageAction,
  UploadServiceCallImageThunk,
  setSupportEventsCountToShowAction,
  setSupportEventsActivePageAction,
} from './SupportActions';
import { SUPPORT_NAMESPACE } from './SupportReducer';
import { SupportState } from './SupportTypes';

export function useResourceManagementSelector<
  T extends (state: SupportState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) => selector(state[SUPPORT_NAMESPACE]));
}

export const useSupportEvents = () =>
  useResourceManagementSelector((state) => {
    return state.supportEvents.events;
  });

export const useSupportCategories = () =>
  useResourceManagementSelector((state) => {
    return state.supportCategories;
  });

export const useSupportCategoryById = (id: string) =>
  useResourceManagementSelector((state) => {
    return state.supportCategories.find((category) => category.id === +id);
  });

export const useSupportSubCategories = () =>
  useResourceManagementSelector((state) => {
    return state.supportSubCategories;
  });

export const useSupportSubSubCategories = (subCategoryId: number) =>
  useResourceManagementSelector((state) => {
    return (
      state.supportSubCategories.find((item) => item.id === subCategoryId)
        ?.sub_sub_categories || []
    );
  });

export const useSupportSubCategoryById = (id: string) =>
  useResourceManagementSelector((state) => {
    return state.supportSubCategories.find(
      (subCategory) => subCategory.id === +id
    );
  });

export const useSupportEventsPagination = () =>
  useResourceManagementSelector((state) => {
    return state.supportEvents.pagination;
  });

export const useCreateServiceCall = () =>
  useAppAction(createNewServiceCallThunk);
export const useFetchSupportCategories = () =>
  useAppAction(FetchSupportCategoriesThunk);
export const useUploadServiceCallImage = () =>
  useAppAction(UploadServiceCallImageThunk);
export const useFetchSupportEvents = () =>
  useAppAction(FetchSupportEventsThunk);
export const useRemoveServiceCallImage = () =>
  useAppAction(removeSupportImageAction);
export const useFetchSupportSubCategories = () =>
  useAppAction(FetchSupportSubCategoriesByCategoryIdThunk);
export const useClearSupportImage = () => useAppAction(clearSupportImage);

export const useSetSupportEventsCountToShow = () =>
  useAppAction(setSupportEventsCountToShowAction);

export const useSetSupportEventsActivePage = () =>
  useAppAction(setSupportEventsActivePageAction);
